import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {MODALS, fetchBooking} from 'ducks/bookings';

import {default as Modal, withModal} from 'components/Modal';

import {CancelBookingForm, Buttons} from './components';

class CancelBookingModal extends React.Component<any> {
  submitForm = () => {
    this.props.submit('cancelBooking');
  };

  getExtraActions = () => {
    const {data: {bookingId, locationRef}} = this.props;

    return [
      ...this.props.closeModalExtraActions,
      () => fetchBooking({locationRef, bookingId})
    ];
  };

  render() {
    const {form: {submitting}, data: {bookingId}} = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.EXTRA_SMALL}
        className="CancelBookingModal">
        <Modal.Header heading="Cancel Booking" />
        <Modal.Body>
          <CancelBookingForm
            bookingId={bookingId}
            getExtraActions={this.getExtraActions}
          />
        </Modal.Body>

        <Modal.Footer>
          <Buttons
            submitForm={this.submitForm}
            submitting={submitting}
            closeModal={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  form: {
    submitting: isSubmitting('cancelBooking')(state)
  }
});

const mapDispatchToProps = {submit};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.CANCEL_BOOKING)(CancelBookingModal)
);
